var React = require('react');

function MJD (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mobile Micro Jump Drive"),React.createElement("g",{"id":"g1622","key":2},[React.createElement("path",{"id":"path3685-7-4","className":"cls-1","d":"M34,44,54,64,34,84","key":0}),React.createElement("path",{"id":"path3892","className":"cls-1","d":"M34,24H14v80H34","key":1}),React.createElement("path",{"id":"path3685-7-4-9","className":"cls-1","d":"M64,44,84,64,64,84","key":2}),React.createElement("path",{"id":"path3685-7-4-0","className":"cls-1","d":"M94,44l20,20L94,84","key":3})])]);
}

MJD.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = MJD;

MJD.default = MJD;
